import { post } from "@/utils/utils";

const microShop = {
  state: {
    microShopGoodsCategoryList: {},
    addMicroShopGoodsCategoryCode: "",
    microShopGoodsCategoryDetails: {},
    editMicroShopGoodsCategoryCode: "",
    microShopGoodsCategoryTree: [],
    microShopGoodsList: {},
    allMicroShopGoodsList: {},
    microShopStoreList: [],
    dkMicroShopStoreList:[] ,
    microShopGoodsDetails: {},
    batchEditMicroShopGoodsCode: ""
  },
  mutations: {
    ADD_MICRO_SHOP_GOODS(state, data) {
      state.addMicroShopGoodsCode = data.result;
    },
    EDIT_MICRO_SHOP_GOODS(state, data) {
      state.aditMicroShopGoodsCode = data.result;
    },
    QUERY_MICRO_SHOP_GOOD_CATEGORY_LIST(state, data) {
      state.microShopGoodsCategoryList = data.result;
      if (
        state.microShopGoodsCategoryList.records &&
        state.microShopGoodsCategoryList.records.length
      ) {
        state.microShopGoodsCategoryList.records.forEach(v => {
          v.hasChildren = Boolean(v.isChild);
        });
      }
    },
    QUERY_MICRO_SHOP_GOOD_CATEGORY_LIST_BY_PARENT(state, data) {
      state.microShopGoods = data.result;
    },
    ADD_MICRO_SHOP_GOODS_CATEGORY(state, data) {
      state.addMicroShopGoodsCategoryCode = data.code;
    },
    EDIT_MICRO_SHOP_GOODS_CATEGORY(state, data) {
      state.editMicroShopGoodsCategoryCode = data.code;
    },
    QUERY_MICRO_SHOP_GOODS_CATEGORY_DETAILS(state, data) {
      state.microShopGoodsCategoryDetails = data.result;
    },
    QUERY_MICRO_SHOP_GOODS_CATEGORY_TREE(state, data) {
      state.microShopGoodsCategoryTree = data.result;
      if (
        state.microShopGoodsCategoryTree &&
        state.microShopGoodsCategoryTree.length
      ) {
        state.microShopGoodsCategoryTree.forEach(v => {
          v.leaf = Boolean(!v.isChild);
        });
      }
    },
    DELETE_MICRO_SHOP_GOODS_CATEGORY(state, data) {
      state.deleteMicroShopCode = data.code;
    },
    QUERY_MICRO_SHOP_GOODS_LIST(state, data) {
      data.result.records.forEach(v => {
        v.retailPrice = v.showPrice;
        v.bargainTotalStockSum = v.stockNum;
        v.edit_enddate = true;
      });
      state.microShopGoodsList = data.result;
    },
    QUERY_MICRO_SHOP_GOODS_LIST_NEW() {},
    QUERY_MICRO_SHOP_GOODS_LIST_NEWS() {},
    QUERY_ALL_MICRO_SHOP_GOODS_LIST(state, data) {
      state.allMicroShopGoodsList = data.result.records;
    },
    QUERY_MICRO_SHOP_STORE_LIST(state, data) {
      state.microShopStoreList = data.result;
    },
    QUERY_DK_MICRO_SHOP_STORE_LIST(state, data) {
      state.dkMicroShopStoreList = data.result;
    },
    QUERY_MICRO_SHOP_GOODS_DETAILS(state, data) {
      state.microShopGoodsDetails = data.result;
    },
    BATCH_EDIT_MICRO_SHOP_GOODS(state, data) {
      state.batchEditMicroShopGoodsCode = data.result;
    },
    QUERY_MICRO_GOODS_DETAIL(state, data) {
      state.queryMicgood = data.result;
    },
    ADD_GROUP_PRICE(state, data) {
      state.addgroup = data.result;
    },
    EDIT_GROUP_PRICE(state, data) {
      state.editgroup = data.result;
    },
    QUERY_EXPORT_MICRO_SHOP_GOODS_LIST() {},
    EDIT_WX_SHOP_SPU_NAME() {},
    QUERY_PROD_PLACE_LIST() {},
    QUERY_BONDED_AREA_LIST() {},
    ADD_BONDED_AREA() {},
    DEL_BONDED_AREA() {},
    BATCH_MEMBER_PRICE_ADD() {},
    BATCH_BIND_EXPRESS() {},
    DEL_WX_SHOP_SUPGOODS() {},
    QUERY_RECYCLE_LIST() {},
    RECYCLE() {},
    WX_GOODS_HIDE() {},
    WX_SKU_EXPORT() {},
    WX_PRICE_VERIFICATION() {},
    QUERY_ISSHOW_OVERAWA() {},
    IMPORT_WX_SHOP_SPU_LIST() {},
    WX_SHOP_SPU_RELATION_INFO(){},
    QUERY_REL_WXSHOP_SPU_INFO_PAGE_LIST_BY_RELATION_ID(){},
    WXSHOP_SPU_RELATION_INFO_ADD_ALL(){},
    WXSHOP_SPU_RELATION_INFO_DELETE(){},
    WXSHOP_SPU_RELATION_REL_ADD(){},
    WXSHOP_SPU_RELATION_REL_DELETE(){},
    THIRD_ORDER_REFUND_LIST() {},
    NOT_USED_GOODS() {},
    QUERY_ALL_MICRO_SHOP_GOODS_LIST_NEW() {},
    QUERY_ALL_MICRO_SHOP_GOODS_LIST_NEWS() {},
    GOODS_WRITE_BLACK_LIST() {},
    GOODS_WRITE_BLACK_DELETE() {},
    ADD_GOODS_WRITE_BLACK_RECORD() {},
    UPDATE_SEQ_NUM() {},
    EDIT_WXSHOP_SPU_NICK_NAME() {},
    QUERY_INFO_LIST_WITH_PAGET() {},
    BATCH_UPDATE_PRICE() {},
    BATH_EDIT_WXSHOP_STOCK_TIPS() {},
    PLUS_DUANXIN_LEIXIN() {},
    PLUS_DUANXIN_TIANSHU() {},
    PLUS_DUANXIN_KAIGUAN() {},
    QUERY_WXSHOP_SKU_INFO_LIST_WITH_PAGE() {},
  },
  actions: {
     // 商品写入pos黑名单列表
     goodsWriteBlackList({ commit}, params) {
       return post({
         commit,
         url: `/goodsWriteBlackRecord/list`,
         name: "GOODS_WRITE_BLACK_LIST",
         params
       });
     },
     // 添加pos写入没名单商品
     addBlackRecord({ commit }, params) {
       return post({
         commit,
         url: `/goodsWriteBlackRecord/add`,
         name: "ADD_GOODS_WRITE_BLACK_RECORD",
         params
       });
     },
     // 商品写入pos黑名单删除
     goodsWriteBlackListDelete({commit}, params) {
       return post({
         commit,
         url: `/goodsWriteBlackRecord/delete`,
         name: "GOODS_WRITE_BLACK_DELETE",
         params
       });
     },
     // 微店商品关联组查询
     wxshopSpuRelationInfo({ commit }, params) {
      return post({
        commit,
        url: `/relation/wxshopSpuRelationInfo/queryPageList`,
        name: "WX_SHOP_SPU_RELATION_INFO",
        params
      });
    },
     // 微店商品关联组-行删除
     wxshopSpuRelationInfoDelete({ commit }, params) {
      return post({
        commit,
        url: `/relation/wxshopSpuRelationInfo/delete`,
        name: "WXSHOP_SPU_RELATION_INFO_DELETE",
        params
      });
    },
    // 微店商品关联组内商品-行删除
    wxshopSpuRelationRelDelete({ commit }, params) {
      return post({
        commit,
        url: `/relation/wxshopSpuRelationRel/delete`,
        name: "WXSHOP_SPU_RELATION_REL_DELETE",
        params
      });
    },
    // 关联商品管理,根据relationId查询关联商品
    queryRelWxshopSpuInfoPageListByRelationId({ commit }, params) {
      return post({
        commit,
        url: `/relation/wxshopSpuRelationRel/queryRelWxshopSpuInfoPageListByRelationId`,
        name: "QUERY_REL_WXSHOP_SPU_INFO_PAGE_LIST_BY_RELATION_ID",
        params
      });
    },
    // 关联商品管理,追加商品
    wxshopSpuRelationRelAdd({ commit }, params) {
      return post({
        commit,
        url: `/relation/wxshopSpuRelationRel/add`,
        name: "WXSHOP_SPU_RELATION_REL_ADD",
        params
      });
    },
    queryExportMicroShopGoodsList({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/sku_export_list`,
        name: "QUERY_EXPORT_MICRO_SHOP_GOODS_LIST",
        params
      });
    },
    batchEditMicroShopGoods({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/batch_edit`,
        name: "BATCH_EDIT_MICRO_SHOP_GOODS",
        params
      });
    },
    editMicroShopGoods({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/edit`,
        name: "EDIT_MICRO_SHOP_GOODS",
        params
      });
    },
    queryMicroShopGoodsDetails({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/detail`,
        name: "QUERY_MICRO_SHOP_GOODS_DETAILS",
        params
      });
    },
    queryMicroStoreList({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/shop_list`,
        name: "QUERY_MICRO_SHOP_STORE_LIST",
        params
      });
    },
    queryDkMicroStoreList({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/dk_shop_list`,
        name: "QUERY_DK_MICRO_SHOP_STORE_LIST",
        params
      });
    },
    // 商品关联编码和商品信息同时保存接口
    wxshopSpuRelationInfoAddAll({ commit }, params) {
      return post({
        commit,
        url: `/relation/wxshopSpuRelationInfo/addAll`,
        name: "WXSHOP_SPU_RELATION_INFO_ADD_ALL",
        params
      });
    },
    //修改排序
    updateSeqNum({ commit }, params) {
      return post({
        commit,
        url: `/relation/wxshopSpuRelationRel/updateSeqNum`,
        name: "UPDATE_SEQ_NUM",
        params
      });
    },
    //修改简称
    editWxshopSpuNickName({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/editWxshopSpuNickName`,
        name: "EDIT_WXSHOP_SPU_NICK_NAME",
        params
      });
    },


// 通用-获取微店列表
    queryMicroShopGoodsList({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/list`,
        name: "QUERY_MICRO_SHOP_GOODS_LIST",
        params
      });
    },
    // 通用-获取微店特价列表
    queryMicroShopGoodsListNew({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/list`,
        name: "QUERY_MICRO_SHOP_GOODS_LIST_NEW",
        params
      });
    },
    // 通用-获取微店新品列表
    queryMicroShopGoodsListNews({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/list`,
        name: "QUERY_MICRO_SHOP_GOODS_LIST_NEWS",
        params
      });
    },
    // 微店商品关联-导入数据
    queryWxshopSpuRelationRelImportData({ commit }, params) {
      return post({
        commit,
        url: `/relation/wxshopSpuRelationRel/importData`,
        name: "QUERY_WXSHOP_SPU_RELATION_REL_IMPORT_DATA",
        params
      });
    },
    queryAllMicroShopGoodsList({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/list`,
        name: "QUERY_ALL_MICRO_SHOP_GOODS_LIST",
        params
      });
    },
    queryAllMicroShopGoodsListNew({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/list`,
        name: "QUERY_ALL_MICRO_SHOP_GOODS_LIST_NEW",
        params
      });
    },
    queryAllMicroShopGoodsListNews({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/list`,
        name: "QUERY_ALL_MICRO_SHOP_GOODS_LIST_NEWS",
        params
      });
    },
    addMicroShopGoods({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/add`,
        name: "ADD_MICRO_SHOP_GOODS",
        params
      });
    },
    queryMicroShopGoodsCategoryListByParent({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopcategory/basic_list`,
        name: "QUERY_MICRO_SHOP_GOOD_CATEGORY_LIST_BY_PARENT",
        params
      });
    },
    queryMicroShopGoodsCategoryListByParentNew({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopcategory/basic_list_new`,
        name: "QUERY_MICRO_SHOP_GOOD_CATEGORY_LIST_BY_PARENT",
        params
      });
    },
    queryMicroShopGoodsCategoryList({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopcategory/basic_list`,
        name: "QUERY_MICRO_SHOP_GOOD_CATEGORY_LIST",
        params
      });
    },
    queryMicroShopGoodsCategoryListNew({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopcategory/basic_list_new`,
        name: "QUERY_MICRO_SHOP_GOOD_CATEGORY_LIST",
        params
      });
    },
    deleteMicroShopGoodsCategory({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopcategory/del`,
        name: "DELETE_MICRO_SHOP_GOODS_CATEGORY",
        params
      });
    },
    addMicroShopGoodsCategory({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopcategory/add`,
        name: "ADD_MICRO_SHOP_GOODS_CATEGORY",
        params
      });
    },
    queryMicroShopGoodsCategoryDetails({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopcategory/detail`,
        name: "QUERY_MICRO_SHOP_GOODS_CATEGORY_DETAILS",
        params
      });
    },
    editMicroShopGoodsCategory({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopcategory/edit`,
        name: "EDIT_MICRO_SHOP_GOODS_CATEGORY",
        params
      });
    },
    queryMicroShopGoodsCategoryTree({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopcategory/tree`,
        name: "QUERY_MICRO_SHOP_GOODS_CATEGORY_TREE",
        params
      });
    },
    queryMicroGoodsDetails({ commit }, params) {
      return post({
        commit,
        url: `/clusterGoods/storeSkuPlatformCustomPriceInfo/query_by_spuId`,
        name: "QUERY_MICRO_GOODS_DETAIL",
        params
      });
    },
    addGroupPrice({ commit }, params) {
      return post({
        commit,
        url: `/clusterGoods/storeSkuPlatformCustomPriceInfo/add`,
        name: "ADD_GROUP_PRICE",
        params
      });
    },
    editGroupPrice({ commit }, params) {
      return post({
        commit,
        url: `/clusterGoods/storeSkuPlatformCustomPriceInfo/edit`,
        name: "EDIT_GROUP_PRICE",
        params
      });
    },
    editWxshopSpuName({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/edit_name`,
        name: "EDIT_WX_SHOP_SPU_NAME",
        params
      });
    },
    queryProdPlaceList({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/queryProdPlaceList`,
        name: "QUERY_PROD_PLACE_LIST",
        params
      });
    },
    queryBondedAreaList({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/queryBondedAreaList`,
        name: "QUERY_BONDED_AREA_LIST",
        params
      });
    },
    addBondedArea({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/addBondedArea`,
        name: "ADD_BONDED_AREA",
        params
      });
    },
    delBondedArea({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/delBondedArea`,
        name: "DEL_BONDED_AREA",
        params
      });
    },
    batchMemberPriceAdd({ commit }, params) {
      return post({
        commit,
        url: `/clusterGoods/storeSkuPlatformCustomPriceInfo/batch_add`,
        name: "BATCH_MEMBER_PRICE_ADD",
        params
      });
    },
    batchBindExpress({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/batch_bind_express`,
        name: "BATCH_BIND_EXPRESS",
        params
      });
    },
    delWxshopspuGoods({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/delete`,
        name: "DEL_WX_SHOP_SUPGOODS",
        params
      });
    },
    queryRecycleList({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/recycle_list`,
        name: "QUERY_RECYCLE_LIST",
        params
      });
    },
    recycle({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/recycle`,
        name: "RECYCLE",
        params
      });
    },
    wxGoodsHide({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/hide`,
        name: "WX_GOODS_HIDE",
        params
      });
    },
    wxSkuExport({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/sku_export?false`,
        name: "WX_SKU_EXPORT",
        params
      });
    },

    wxPriceVerification({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/wxShopPriceCompare?false`,
        name: "WX_PRICE_VERIFICATION",
        params
      });
    },

    queryShowOverseas({ commit }, params) {
      return post({
        commit,
        url: `/sys/config/query`,
        name: "QUERY_ISSHOW_OVERAWA",
        params
      });
    },
    importWxshopSpuInfo({ commit }, params) {
      return post({
        commit,
        url: `/customer_search/importWxshopSpuInfo?false`,
        name: "IMPORT_WX_SHOP_SPU_LIST",
        params
      });
    },
    third_order_refund_list({ commit }, params) {
      return post({
        commit,
        url: `/order/third_order_refund_list`,
        name: "THIRD_ORDER_REFUND_LIST",
        params
      });
    },
    notUsedGoods({commit}, params) {
       return post({
         commit,
         url: `/relation/wxshopSpuRelationRel/queryRelWxshopSpuInfoPageListNotUsed`,
         name: "NOT_USED_GOODS",
         params
       })
    },
    queryInfoListWithPage({ commit }, params) {
      return post({
        commit,
        url: `/back/wxshopspu/search/queryInfoListWithPage`,
        name: "QUERY_INFO_LIST_WITH_PAGET",
        params
      });
    },
    batchUpdatePrice({ commit }, params) {
      return post({
        commit,
        url: `/basic/wxshopspu/batch_update_price`,
        name: "BATCH_UPDATE_PRICE",
        params
      });
    },
    bathEditWxshopStockTips({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/getUiTextByTextCode?textCode=bath_edit_wxshop_stock_tips`,
        name: "BATH_EDIT_WXSHOP_STOCK_TIPS",
        params
      });
    },
    plusDuanxinLeixin({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/getUiTextByTextCode?textCode=plus_duanxin_leixin`,
        name: "PLUS_DUANXIN_LEIXIN",
        params
      });
    },
    plusDuanxinTianshu({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/getUiTextByTextCode?textCode=plus_duanxin_tianshu`,
        name: "PLUS_DUANXIN_TIANSHU",
        params
      });
    },
    plusDuanxinKaiguan({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/getUiTextByTextCode?textCode=plus_duanxin_kaiguan`,
        name: "PLUS_DUANXIN_KAIGUAN",
        params
      });
    },
    queryWxshopSkuInfoListWithPage({ commit }, params) {
      return post({
        commit,
        url: `/back/wxshopsku/search/queryWxshopSkuInfoListWithPage`,
        name: "QUERY_WXSHOP_SKU_INFO_LIST_WITH_PAGE",
        params
      });
    },
  }
};

export default microShop;
